import { UseFormReturn } from 'react-hook-form';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import {
  useDrawingContext,
  useDrawingLifecycle,
  useResetDrawingContext,
} from './DrawingContext';
import { DrawGeometryType } from '../isDrawGeometryType';
import { createGeometryFromGeoJson } from '@ais-ui/utils';
import { DrawingStyles } from '../styles/getDrawingStyle';
import { propagateGeometryChanges } from '../propagateGeometryChanges';

export const useDrawFromDialog = (
  form: UseFormReturn<any>,
  setShowDialog: (showDialog: boolean) => void,
  geometryField = 'geometry',
  drawingStyle?: DrawingStyles
) => {
  const { onStartDrawing, onAcceptDrawing } = useDrawingLifecycle();
  const resetDrawingContext = useResetDrawingContext();
  const { setShowDrawPanel, onFinish, onCancel, onAccept } =
    useDrawingContext();
  const onAcceptDrawingFromDialog = () => {
    const geojson = onAcceptDrawing();
    if (!geojson) return;

    const geometry = createGeometryFromGeoJson(geojson);

    propagateGeometryChanges(geometry, geometryField, form);

    resetDrawingContext();
    onAccept.current = null;
    onFinish.current = null;
    onCancel.current = null;
    setShowDrawPanel(false);
    setShowDialog(true);
  };

  const onCancelDrawingFromDialog = () => {
    resetDrawingContext();
    onAccept.current = null;
    onFinish.current = null;
    onCancel.current = null;
    setShowDialog(true);
  };

  const onStartDrawingFromDialog = (
    geometryType: DrawGeometryType,
    shape: GeoJson | undefined | null,
    maxPoints?: number
  ) => {
    onAccept.current = onAcceptDrawingFromDialog;
    onCancel.current = onCancelDrawingFromDialog;
    onStartDrawing(geometryType, shape, true, drawingStyle, maxPoints);
    setShowDialog(false);
  };

  return {
    onAcceptDrawingFromDialog,
    onStartDrawingFromDialog,
    onCancelDrawingFromDialog,
  };
};
